import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";
import { resetPassword } from "../lib/customerApi";

export default function AccountReset() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters."); return; }
    if (password !== confirm) { toast.error("Passwords don't match."); return; }
    setLoading(true);
    try {
      await resetPassword(token, password);
      toast.success("Password updated — please sign in.");
      navigate("/account/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed. Request a new link.");
    } finally { setLoading(false); }
  };

  const input = "w-full bg-transparent border-b border-[#3a3a3a] focus:border-gold py-3.5 text-white placeholder:text-zinc-600 outline-none transition-colors";

  return (
    <main className="min-h-screen grid place-items-center px-5 pt-24 pb-16" data-testid="account-reset-page">
      <div className="w-full max-w-md bg-[#121212] border border-[#27272a] p-8 sm:p-10">
        <div className="h-11 w-11 grid place-items-center border border-gold text-gold mb-6"><KeyRound size={20} /></div>
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-gold">[ Reset Password ]</span>
        <h1 className="font-display text-3xl font-semibold uppercase tracking-tight mt-3 mb-7">Set A New Password</h1>
        {!token ? (
          <p className="text-zinc-400 text-sm">This reset link is missing its token. <Link to="/account/login" className="text-gold hover:underline">Request a new one</Link>.</p>
        ) : (
          <form onSubmit={submit} className="space-y-6">
            <input type="password" className={input} placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" />
            <input type="password" className={input} placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" />
            <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-gold text-black font-mono text-xs uppercase tracking-[0.15em] px-6 py-4 font-semibold hover:bg-[#d59e19] transition-colors disabled:opacity-60" data-testid="reset-submit">
              {loading ? <Loader2 size={16} className="animate-spin" /> : "Update Password"}
            </button>
          </form>
        )}
      </div>
    </main>
  );
}
